
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmpresaService } from 'src/app/admihair/service/empresa.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { EventBusService } from 'src/app/admihair/shared/event-bus.service';
import { Subscription } from 'rxjs';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Table } from 'primeng/table';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { UsuarioPermissaoEmpresaService } from '../../service/usuario-permissao-empresa.service';
import { Permissao } from '../../api/dto/permissao';
import { PermissaoService } from '../../service/permissao.service';
import { AuthService } from '../../service/auth.service';
import { Message } from 'primeng/api';
import { ErroService } from '../../service/erro.service';

@Component({
  selector: 'app-selecionar-empresa',
  templateUrl: './selecionar-empresa.component.html',
  styleUrls: ['./selecionar-empresa.component.scss']
})
export class SelecionarEmpresaComponent {

  constructor(private empresaService: EmpresaService,
    private authService: AuthService,
    private permissaoService: PermissaoService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService,
    private eventBusService: EventBusService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private layoutService: LayoutService) { }

  isLoggedIn = false;
  acesso?: any;
  eventBusSub?: Subscription;
  empresas: Empresa[] = [];
  loadingEmpresas: boolean = false;
  loading: boolean = false;
  messages: Message[] = [];

  @ViewChild('filter') filter!: ElementRef;
  ngOnInit(): void {

    this.loadingEmpresas = true;
    this.layoutService.state.profileSidebarVisible = false;
    this.isLoggedIn = !!this.utilStorageService.getToken();

    if (this.isLoggedIn) {
      this.acesso = this.utilStorageService.getUser();
    }

    this.eventBusSub = this.eventBusService.on('logout', () => {
      this.logout();
    });
    this.listarEmpresas(this.acesso.usuario.id);
  }

  listarEmpresas(id: number) {
    this.empresaService.listarPorUsuarioId(id).subscribe(
      (data) => {
        this.loadingEmpresas = false;
        if (data.length > 1) {
          this.empresas = data;
        }
        if (data.length == 1) {
          this.selecionarEmpresa(data[0]);
        }
        if (data.length == 0) {

          this.redirecionarSemVinculoEmpresa();
        }
      },
      (error) => {
        this.loadingEmpresas = false;
        console.error('Error:', error);
      }
    );
  }

  selecionarEmpresa(empresa: Empresa) {
    this.loadingEmpresas = true;


    this.authService.selecionarEmpresa(empresa.id).subscribe({
      next: (data: any) => {
        this.utilStorageService.saveToken(data.token);
        this.utilStorageService.saveRefreshToken(data.refreshToken);
        this.utilStorageService.saveUser(data);
        this.listarPermissoesPorUsuarioEEmpresa(this.acesso.usuario.id, empresa);
      },
      error: (err: any) => {

      }
    })
  }

  listarPermissoesPorUsuarioEEmpresa(usuarioId?: number, empresa?: Empresa) {
    if (empresa) {
      this.permissaoService.listarPorEmpresaEUsuario(empresa.id, usuarioId).subscribe({
        next: (data: String[]) => {
          this.utilStorageService.saveEmpresa(empresa);
          this.utilStorageService.savePermissoes(data);
          this._router.navigate(["/apps/dashboard"], { relativeTo: this._activatedRoute });
        },
        error: (err: any) => {
          console.log(err)
          this.loadingEmpresas = false;
          this.messages = this.erroService.handleErro(err);
          

        }
      })
    }

  }


  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  logout(): void {
    this.utilStorageService.signOut();

    this.isLoggedIn = false;
    this.navigateToFirstChild();
  }

  navigateToFirstChild() {
    this._router.navigate(["/auth/login"], { relativeTo: this._activatedRoute })
  }

  redirecionarSemVinculoEmpresa() {
    this._router.navigate(["/auth/access-yet"], { relativeTo: this._activatedRoute })
  }

  get dark(): boolean {
    return this.layoutService.config.colorScheme !== 'dark';
  }

}
